import React from "react";

interface IconProps {
  name: string;
  width?: number;
  height?: number;
  size?: number;
  fill?: string;
  stroke?: string;
  className?: string;
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
  name,
  width = 24,
  height = 24,
  size = 24,
  fill = "none",
  stroke = "none",
  className = "",
  onClick,
}) => {
  return (
    <svg
      className={`pointer-events-none ${className}`}
      width={size || width}
      height={size || height}
      fill={fill}
      stroke={stroke}
      onClick={onClick}
    >
      <use xlinkHref={`/svgs/sprite-v11.svg#${name}`} />
    </svg>
  );
};

export default Icon;
